import styled from 'styled-components'

const StyledPhotos = styled.div`
  position: relative;
`

export default StyledPhotos
